module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maria San Filippo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Maria San Filippo has taught film and television studies, and gender and sexuality studies, at MIT, Harvard University, UCLA, and Wellesley College. Her work has appeared in the journals CineAction, Cineaste, English Language Notes, Film History, In Media Res, Journal of Bisexuality, Quarterly Review of Film and Video, and Senses of Cinema and the anthologies Global Art Cinema and Millennial Masculinity: Men in Contemporary American Cinema.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/j2jmaI/tc-custom/9780253008923.jpg?1737196287342",
      "alt": "This image is the cover for the book B Word"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("B Word\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Often disguised in public discourse by terms like \"gay,\" \"homoerotic,\" \"homosocial,\" or \"queer,\" bisexuality is strangely absent from queer studies and virtually untreated in film and media criticism. Maria San Filippo aims to explore the central role bisexuality plays in contemporary screen culture, establishing its importance in representation, marketing, and spectatorship. By examining a variety of media genres including art cinema, sexploitation cinema and vampire films, \"bromances,\" and series television, San Filippo discovers \"missed moments\" where bisexual readings of these texts reveal a more malleable notion of subjectivity and eroticism. San Filippo's work moves beyond the subject of heteronormativity and responds to \"compulsory monosexuality,\" where it's not necessarily a couple's gender that is at issue, but rather that an individual chooses one or the other. The B Word transcends dominant relational formation (gay, straight, or otherwise) and brings a discursive voice to the field of queer and film studies.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0